import { useEffect } from 'react';

function useAutoPauseOnViewportExit(playerRef, isPlaying, pause) {
  useEffect(() => {
    const player = playerRef.current;
    if (!player || !isPlaying) {
      return;
    }
    const onIntersectionUpdate = entries => {
      const entry = entries[0];

      // In case our item has left the viewport then auto-pause the audio
      if (!entry?.isIntersecting) {
        pause();
      }
    };
    const observer = new IntersectionObserver(onIntersectionUpdate, {
      threshold: 0
    });
    observer.observe(player);
    return () => {
      observer.disconnect();
    };
  }, [isPlaying, pause, playerRef]);
}

export { useAutoPauseOnViewportExit };
//# sourceMappingURL=use-pause-on-viewport-exit.js.map
